import { render } from "./ModalUnsubscribePopup.vue?vue&type=template&id=2caa2ec7&scoped=true"
import script from "./ModalUnsubscribePopup.vue?vue&type=script&lang=js"
export * from "./ModalUnsubscribePopup.vue?vue&type=script&lang=js"

import "./ModalUnsubscribePopup.vue?vue&type=style&index=0&id=2caa2ec7&scoped=true&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2caa2ec7"]])

export default __exports__